import { css } from '@emotion/core';

export const openMenu = (open: boolean) => css`
	height: ${open ? '100vh' : '0'};
	opacity: ${open ? 1 : 0};
	pointer-events: ${open ? 'all' : 'none'};
	transition: height 0.35s, opacity 0.35s, transform 0.35s;
`;
